import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { appPlatform } from "@/lib/platform";
import { autoSyncStore } from "@/lib/iap";

export const IAP_SYNCED_EVENT = "yalola:iap_synced";

// Apps natives uniquement : à chaque session (connexion, démarrage avec session), restauration SILENCIEUSE des achats
// RevenueCat du compte (nouvel iPhone / Android, réinstallation) — jamais de fenêtre Apple ID. 1 fois / 24 h / appareil.
export const IapAutoSync = () => {
  const { user, loading, config, refreshMe, t } = useApp();
  const doneFor = useRef(null);
  const iapOn = !!(config?.payments?.iap?.apple_enabled || config?.payments?.iap?.google_enabled);
  useEffect(() => {
    if (loading || !user?.id || !iapOn || appPlatform() === "web") return;
    if (doneFor.current === user.id) return;
    doneFor.current = user.id;
    const wasVerified = !!user.is_verified;
    (async () => {
      const r = await autoSyncStore({ payments: config.payments, userId: user.id });
      if (!r?.sync) return;
      window.dispatchEvent(new CustomEvent(IAP_SYNCED_EVENT, { detail: r.sync }));
      if (!wasVerified && r.sync.verified?.is_verified) {
        toast.success(t("iap.auto_restored", "Achats restaurés : ton badge Yalola Vérifié est de retour ✓"));
        refreshMe?.().catch?.(() => {});
      }
    })();
  }, [loading, user?.id, iapOn]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};
